<template>
    <!-- 课票订单详情-票券订单列表  用户票券管理 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'sendDetail')">
            <div slot="header" style="padding: 0px 16px;">
                <div>【用户票券号：{{userTicketId}} 】的赠送详情</div>
                <div class="mb8 mt8">
                    <span class="mr32">用户票券id: {{userTicketId || '--'}}</span>
                    <span class="mr32">参与活动名称: {{activityName || '--'}}</span>
                    <span class="mr32">活动id: {{ticketGiveId || '--'}}</span>
                </div>
            </div>
            <div class="wrap-container-in">
                <div v-for="(item, index) in giveList" :key="index">
                    <p class="mb16 mt16" style="font-size: 16px;">{{item}}</p>
                    <a-table :rowClassName="(record, index) => index" bordered :dataSource="dataSourceGive[index] || []" :columns="columnsGive[index]" :pagination="false" :rowKey="(record, index) => index">
                    <span slot="num" slot-scope="a, row">{{a === -1 ? '不限次' : a}}</span>
                    <span slot="expireDate" slot-scope="a, row">{{row.expireDate && row.expireDate.substring(0,10)}}</span>
                    <span slot="action" slot-scope="a, row" >
                        <template v-if="row.userTicketNo">
                            <a class="text-primary" v-if="Boolean(['已禁用'].find(item => item === row.statusStr))" @click="forbidden(row.userTicketNo, false)">取消禁用</a>
                            <a class="text-primary" v-else-if="Boolean(['已生效'].find(item => item === row.statusStr))" @click="forbidden(row.userTicketNo, true)">禁用</a>
                            <span v-else class="text-disabled">禁用</span>
                        </template>
                        <template v-if="row.userCouponId">
                            <a-popconfirm
                                v-if="Boolean(['未使用'].find(item => item === row.statusStr))"
                                title="确认禁用吗？"
                                @confirm="couponState(row)"
                            >
                                <a class="text-primary">禁用</a>
                            </a-popconfirm>
                            <span v-else class="text-disabled">禁用</span>
                        </template>
                    </span>
                </a-table>
                </div>
            </div>
            <member-order-forbidden ref="forbiddenModal" @ok="userTicketGiveDetails"></member-order-forbidden>
        </content-view>
    </div>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import memberOrderForbidden from '@/components/modules/order/member-order-forbidden.component';
    const giveGrantUserTicketVos = [
        {
            title: "用户票券id",
            dataIndex: "userTicketNo",
            scopedSlots: { customRender: "userTicketNo" }
        },
        {
            title: "票券名称",
            dataIndex: "goodsName"
        },
        {
            title: "票券状态",
            dataIndex: "statusStr"
        },
        {
            title: "总次数",
            dataIndex: "totalNum",
            scopedSlots: { customRender: "num" }
        },
        {
            title: "剩余次数",
            dataIndex: "surplusNum",
            scopedSlots: { customRender: "num" }
        },
        {
            title: "到期日",
            dataIndex: "expireDate",
            scopedSlots: { customRender: "expireDate" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const giveGrantUserAddTicketVos = [
        {
            title: "用户票券id",
            dataIndex: "userTicketNo",
        },
        {
            title: "票券名称",
            dataIndex: "goodsName"
        },
        {
            title: "票券状态",
            dataIndex: "statusStr"
        },
        {
            title: "总次数",
            dataIndex: "totalNum"
        },
        {
            title: "剩余次数",
            dataIndex: "surplusNum",
            scopedSlots: { customRender: "surplusNum" }
        },
        {
            title: "到期日",
            dataIndex: "expireDate",
            scopedSlots: { customRender: "expireDate" }
        },
        {
            title: "加赠理由",
            dataIndex: "state1",
            scopedSlots: { customRender: "state1" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const giveGrantUserCouponVos = [
        {
            title: "用户优惠券id",
            dataIndex: "userCouponId",
            scopedSlots: { customRender: "userCouponId" }
        },
        {
            title: "优惠券适用类型",
            dataIndex: "applyType"
        },
        {
            title: "优惠券名称",
            dataIndex: "goodsName"
        },
        {
            title: "优惠券状态",
            dataIndex: "statusStr"
        },
        {
            title: "到期日",
            dataIndex: "expireDate",
            scopedSlots: { customRender: "expireDate" }
        },
        {
            title: "操作",
            key: "action",
            scopedSlots: { customRender: "action" }
        }
    ];
    const giveGrantBalanceVos = [
        {
            title: "储值金额",
            dataIndex: "balanceAmount",
        },
        {
            title: "发放时间",
            dataIndex: "grantDate"
        },
    ];
    const giveGrantIntegralVos = [
        {
            title: "赠送积分",
            dataIndex: "grantNum",
        },
        {
            title: "发放时间",
            dataIndex: "grantDate"
        },
    ];

    export default {
        name: "sendDetail",
        data() {
            return {
                userTicketId: '',
                activityName: "",
                ticketGiveId: "",
                dataSourceGive: {},
                columnsGive: {
                    giveGrantUserTicketVos,
                    giveGrantUserAddTicketVos,
                    giveGrantUserCouponVos,
                    giveGrantBalanceVos,
                    giveGrantIntegralVos,
                },
                dataSource: [],
                giveList: {
                    giveGrantUserTicketVos: "赠品票券信息",
                    giveGrantUserAddTicketVos: "加赠票券信息",
                    giveGrantUserCouponVos: "赠品优惠券信息",
                    giveGrantBalanceVos: "赠品储值信息",
                    giveGrantIntegralVos: "赠品积分信息"
                }
            };
        },
        components: {
            memberOrderForbidden
        },
        computed: {
            ...mapGetters(["shopId", "shopName"]),
        },
        methods: {
            userTicketGiveDetails() {
                this.$api.order.getGivedDetail({
                    body: {
                        isGiftBonus: true,
                        mainGoodId: this.$route.query.id,
                    }
                }).then(res => {
                    this.dataSourceGive = res;
                    this.activityName = res.activityName;
                    this.ticketGiveId = res.ticketGiveId;
                });
            },
            forbidden(userTicketNo, isForbidden) {
                this.$refs.forbiddenModal.show(userTicketNo, isForbidden);
            },
            couponState(row) {
                this.$api.changeCode.couponState({
                    body: {
                        userCouponNo: row.userCouponId,
                        userId: row.userId,
                        phone: row.phone,
                        shopId: this.shopId,
                        shopName: this.shopName,
                        platformId: -1,
                    }
                }).then(res => {
                    this.userTicketGiveDetails()
                    this.$message.success('操作成功')
                })
            },
        },
        created() {},
        mounted() {
            this.userTicketId = this.$route.query.id;
            this.userTicketGiveDetails();
        },
    };
</script>
<style lang="scss">
.title-ticket {
    margin-bottom: 8px;
    font-size: 16px;
    color: #000;
    font-weight: 700;
}
.tr-active {
    background-color: #fff6ee;
}
.buyOrder {
    padding: 0 16px;
    &-title {
        font-weight: 500;
        font-size: 16px;
    }
    // &-content {
    //     display: flex;
    //     justify-content: space-between;
    // }
}
</style>
